import { render } from "./Message.vue?vue&type=template&id=61d2d687&scoped=true"
import script from "./Message.vue?vue&type=script&lang=js"
export * from "./Message.vue?vue&type=script&lang=js"

import "./Message.vue?vue&type=style&index=0&id=61d2d687&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d2d687"],['__file',"src/components/Message.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "61d2d687"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61d2d687', __exports__)) {
    api.reload('61d2d687', __exports__)
  }
  
  module.hot.accept("./Message.vue?vue&type=template&id=61d2d687&scoped=true", () => {
    api.rerender('61d2d687', render)
  })

}


export default __exports__